import { render, staticRenderFns } from "./TjenesteNettbutikk.vue?vue&type=template&id=afc808b0&"
import script from "./TjenesteNettbutikk.vue?vue&type=script&lang=ts&"
export * from "./TjenesteNettbutikk.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports